import React from 'react';
import Table from '../../common/TableOverView';
import { connect } from 'react-redux';
import { changeSortState, REDUCER_NAME } from '../reducer';
import Const from './Const';

const getDataFromRedux = state =>
  state[REDUCER_NAME].listObjectDataOverviewByTicker;

function TableOverViewVolume(props) {
  const { listId, isLoading, sortState, changeSortState } = props;

  return (
    <Table
      onSort={changeSortState}
      sortState={sortState}
      isLoading={isLoading}
      listId={listId}
      resizable={true}
      columnDraggable={false}
      rowDraggable={false}
      getDataFromRedux={getDataFromRedux}
      hideColumns={Const.listHideColumn}
      listColumns={Const.listColumn}
      i18nTitleKey="topVolume.overview.overviewHeader"
    />
  );
}

const mapStateToProps = state => {
  return {
    listId: state[REDUCER_NAME].listDataOverviewTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  changeSortState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableOverViewVolume);
